import {z} from 'zod';

/**
 * Request schema for getting file metadata from storage service
 */
export const storageFileMetadataRequestSchema = z.object({
  namespace: z.string().optional(),
});

export type StorageFileMetadataRequest = z.infer<typeof storageFileMetadataRequestSchema>;
